import { StatusBadge, type StatusBadgeProps } from "@/shared/components/ui/StatusBadge";
import type { AppointmentStatus } from "../types/appointmentTypes";

const statuses: Record<AppointmentStatus, { label: string; tone: StatusBadgeProps["tone"] }> = {
  pending: { label: "Pending", tone: "pending" },
  confirmed: { label: "Confirmed", tone: "positive" },
  completed: { label: "Completed", tone: "positive" },
  cancelled: { label: "Cancelled", tone: "neutral" },
  declined: { label: "Declined", tone: "danger" },
  no_show: { label: "No show", tone: "danger" },
};

export function AppointmentStatusBadge({ status }: { status: AppointmentStatus }) {
  const { label, tone } = statuses[status];
  return <StatusBadge tone={tone}>{label}</StatusBadge>;
}
